















import { Component, Vue, Prop } from "vue-property-decorator";
import { PLAYER_X, PLAYER_O } from "@/constants";
import "./styles.scss";

@Component({})
export default class MovesList extends Vue {
  @Prop()
  board: string[];

  @Prop()
  histories: string[][];

  @Prop()
  endGame: boolean;

  @Prop()
  opponent: string;

  @Prop()
  nextPlayer: string;

  goBackToMove(event: Event, idx: number) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.endGame) {
      return;
    }
    const board = [...this.histories[idx]];
    const cloneHistories = [...this.histories];
    cloneHistories.splice(idx + 1, cloneHistories.length - 1 - idx);
    this.$emit("update:board", board);
    this.$emit("update:histories", cloneHistories);
    this.$emit("update:nextPlayer", idx % 2 === 0 ? PLAYER_X : PLAYER_O);
  }
}
